var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllstatusinputIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_122779",
    "data-name": "Group 122779",
    transform: "translate(-305 -247)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(305 247)",
    fill: "#1b4a83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-border-all",
    "data-name": "Icon awesome-border-all",
    d: "M11.894,2.25H.915A.915.915,0,0,0,0,3.165V14.144a.915.915,0,0,0,.915.915H11.894a.915.915,0,0,0,.915-.915V3.165A.915.915,0,0,0,11.894,2.25Zm-.915,1.83v3.66H7.319V4.08Zm-5.489,0v3.66H1.83V4.08ZM1.83,13.229V9.569h3.66v3.66Zm5.489,0V9.569h3.66v3.66Z",
    transform: "translate(312.596 252.346)",
    fill: "#fff",
    stroke: "#1b4a83",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllstatusinputIcon);
export default __webpack_public_path__ + "static/media/allstatusinputIcon.d5539018adb93c1d5d2b1cfd313ea26e.svg";
export { ForwardRef as ReactComponent };